import { render, staticRenderFns } from "./NewExampleWithoutWrapper.vue?vue&type=template&id=80ef368a&"
import script from "./NewExampleWithoutWrapper.vue?vue&type=script&lang=js&"
export * from "./NewExampleWithoutWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports